import { Router } from "@frui.ts/screens";
import Region from "entities/region";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import { Modules } from "config";
import EnumRepository from "repositories/enumRepository";
import ConfirmationService from "services/confirmationService";
import SecurityService from "services/securityService";
import ListViewModel from "viewModels/listViewModel";

import RegionCreateViewModel from "./regionCreateViewModel";
import RegionDetailViewModel from "./regionDetailViewModel";

const navigationName = "regions";

@Router.registerRoute({ name: Router.Self, route: navigationName, children: [RegionCreateViewModel, RegionDetailViewModel] })
export default class RegionsViewModel extends ListViewModel<Region, RegionDetailViewModel, RegionCreateViewModel> {
  readonly modelName = "region";

  constructor(
    protected createViewModelFactory: () => RegionCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof RegionDetailViewModel.Factory>,
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected securityService: SecurityService
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected fetchData() {
    return this.repository.postAll("regions", Region, {});
  }

  delete(item: Region): any {
    return this.repository.delete(item, "regions");
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `regions.${code}`, size);
  }
}
